import React, { useEffect } from 'react'
import ReCAPTCHA from 'react-google-recaptcha'
import { useStyles } from './recaptcha.web.styles'
import { ReCaptchaProps } from './recaptcha.web.props'

export const ReCaptcha = (props: ReCaptchaProps) => {
  const { recaptchaRef, isAccountsPage = false } = props
  const styles = useStyles()

  // Add class to body when the modal is open
  // and remove it when the modal is closed
  // This is to prevent the recaptcha from overlapping
  // with the modal when the user is on a mobile device
  useEffect(() => {
    if (isAccountsPage) document.body.classList.add('is-accounts-page')
    return () => {
      if (isAccountsPage) document.body.classList.remove('is-accounts-page')
    }
  }, [isAccountsPage])

  return (
    <div
      data-testid={'reCaptcha'}
      className={isAccountsPage ? styles.recaptchaContainer : ''}
    >
      <ReCAPTCHA
        ref={recaptchaRef}
        size='invisible'
        sitekey={process.env.RECAPTCHA_SITE_KEY!}
      />
    </div>
  )
}
